class WindowEventService {
    private eventRegistry = new Map<string, any>();

    registerEvent<K extends keyof WindowEventMap>(
        uniqueKey: string,
        eventName: K,
        handler: (ev: WindowEventMap[K]) => any
    ) {
        if (this.eventRegistry.get(uniqueKey)) {
            this.removeEvent(uniqueKey, eventName);
        }
        this.eventRegistry.set(uniqueKey, handler);
        window.addEventListener(eventName, handler);
    }

    removeEvent<K extends keyof WindowEventMap>(
        uniqueKey: string,
        eventName: K
    ) {
        if (this.eventRegistry.get(uniqueKey)) {
            window.removeEventListener(
                eventName,
                this.eventRegistry.get(uniqueKey)
            );
            this.eventRegistry.delete(uniqueKey);
        }
    }
}

export default new WindowEventService();
